<template>
  <div class="modal" :id="`modal-ticket-${ticket['Номер']}`">
    <div class="modal-background" v-on:click="closeModal(ticket['Номер'])"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title">
          <strong>Обращение №{{ ticket['Номер'] }}</strong> от {{ ticket['ДатаОбращения'] }}<br>
          <span class="menu-label">{{ticket['ФизическийОбъектОбслНаименование']}}</span><br>
          <div v-if="ticket['Местоположение']" class="subtitle is-6">
            <span>
              <font-awesome-icon icon="fa-solid fa-map-location" />&nbsp;{{ ticket['Местоположение'] }}
            </span>
          </div>
        </div>
        <IconLegend />&nbsp;
        <button class="is-rounded tag button is-danger" aria-label="close" v-on:click="closeModal(ticket['Номер'])">
          <font-awesome-icon icon="fa-solid fa-xmark" />
        </button>
      </header>
      <section class="modal-card-body">
        <div class="content">
          <div class="tag is-dark"><font-awesome-icon icon="fa-solid fa-flag" />&nbsp;{{ ticket['Статус'] }}</div>
          <div class="modal-element">
            <div v-if="edit_mode">
              <textarea class="input" type="text" placeholder="Описание" v-model="new_description" style="margin-bottom: 5px; margin-top: 5px; height: 100px" />
              <div class="columns">
                <div class="column">
                  <button class="button is-danger tag" v-on:click="toggle_edit()">
                    отмена
                  </button>
                </div>
                <div class="column has-text-right">
                  <button class="button tag" :disabled="new_description === ticket['Описание']" :class="new_description !== ticket['Описание'] ? 'is-success' : 'is-transparent'" v-on:click="new_description !== ticket['Описание'] ? save_description() : null">
                    сохранить
                  </button>
                </div>
              </div>


            </div>
            <div v-else>
              <strong>Описание: </strong>{{ ticket['Описание'] }}
              <button class="button is-light tag my-edit-button" v-on:click="toggle_edit()">
                <font-awesome-icon icon="fa-solid fa-pen" class="pen" />
              </button>
            </div>
          </div>
          <p class="modal-element" v-if="ticket['ДопИнформация']"><strong>Доп. информация: </strong>{{ ticket['ДопИнформация'] }}</p>
        </div>
        <hr v-if="ticket['ДатаРеакции'] || ticket['Статус'] === '2. Решено'">
        <div class="content" v-if="ticket['ДатаРеакции']">
          <p class="modal-element"><font-awesome-icon icon="fa-solid fa-arrow-right" /><font-awesome-icon icon="fa-solid fa-street-view" />&nbsp;{{ ticket['ДатаРеакции'] }}</p>
        </div>
        <div class="content" v-if="ticket['РезультатыДиагностики']">
          <p class="modal-element"><strong>Результаты диагностики: </strong>{{ ticket['РезультатыДиагностики'] }}</p>
        </div>
        <div class="content" v-if="ticket['Статус'] === '2. Решено'">
          <p class="modal-element"><font-awesome-icon icon="fa-solid fa-clock-rotate-left" />&nbsp;{{ ticket['РаботоспособностьВосстановлена'] }}</p>
          <p class="modal-element"><strong>Решение: </strong>{{ ticket['Решение'] }}</p>
          <p class="modal-element"><font-awesome-icon icon="fa-solid fa-calendar-check" />&nbsp;{{ ticket['ДатаВыполнения'] }}</p>
        </div>
        <hr v-if="ticket['Исполнитель']">
        <div class="content my-grey" v-if="ticket['Исполнитель']">
          <span class="modal-element"><font-awesome-icon icon="fa-solid fa-user-gear" />&nbsp;{{ ticket['Исполнитель'] }}</span>
        </div>
      </section>
      <footer class="modal-card-foot has-text-centered columns">
        <ReopenTicket v-if="ticket['Статус'] === '2. Решено'" :ticket="ticket" />
        <FinishTicket v-if="ticket['Статус'] !== '2. Решено'" :ticket="ticket" />
        <CancelTicket v-if="ticket['Статус'] !== '2. Решено'" :ticket="ticket" />
        <div class="column has-text-right" v-if="ticket['Статус'] === '2. Решено'">
          <button class="button is-success" v-on:click="closeTicket(ticket['Номер'], ticket['Ссылка'])">Закрыть обращение</button>
        </div>
        <div class="column has-text-right" v-if="ticket['Статус'] !== '2. Решено'">
          <p disabled class="my-subtitle">Закрыть обращение можно только со статусом<br><strong>"2. Решено"</strong></p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import IconLegend from "@/components/IconLegend";
import CancelTicket from "@/components/CancelTicket";
import ReopenTicket from "@/components/ReopenTicket";
import FinishTicket from "@/components/FinishTicket.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "TicketModal",
  components: {FinishTicket, ReopenTicket, CancelTicket, IconLegend },
  props: {
    modelValue: {
      type: [ String, Object, null ],
      required: true
    }
  },
  data() {
    return {
      loader: false,
      objects: null,
      edit_mode: false,
      new_description: null
    }
  },
  computed: {
    ticket: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  methods: {
    save_description: async function () {
      this.loader = true
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/ApplyNewDescription`
      let properies = {
        method: 'POST',
        body: JSON.stringify({
          document: this.ticket['Ссылка'],
          description: this.new_description
        }),
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.json())
          .then(result => {
            if (result && result.status) {
              this.ticket['Описание'] = this.new_description
            }
          }).finally(() => {
            this.loader = false
            this.toggle_edit()
          })
    },
    toggle_edit: function () {
      this.edit_mode = !this.edit_mode
      if (this.edit_mode) {
        this.new_description = this.ticket['Описание']
      } else {
        this.new_description = null
      }
    },
    openMap: async function () {
      let modal = document.getElementById(`modal-map`)
      if (!modal.classList.toString().includes('is-active')) {
        modal.classList.add('is-active')
      }
    },
    closeModal: function (id) {
      let modal = document.getElementById(`modal-ticket-${id}`)
      if (modal.classList.toString().includes('is-active')) {
        modal.classList.remove('is-active')
      }
      this.$store.dispatch('MODAL', {
        status: false,
        data: null
      })
    },
    closeTicket: async function (id, guid) {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/CloseDoc`
      let data = {
        doc_guid: guid
      }
      let properies = {
        method: 'POST',
        body: JSON.stringify(data),
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(result => {
            console.log(result)
            alert('Обращение переведено в статус Закрытое!')
          })
      this.closeModal(id)
    }
  }
}
</script>

<style lang="scss" scoped>
hr {
  margin: 2px 0 !important;
}
.content {
  margin-bottom: 2px !important;
}
.modal {
  backdrop-filter: blur(10px) grayscale(1);
}
.my-grey {
  opacity: 0.5;
}
.modal-element {
  margin: 0 !important;
  padding: 0 !important;
}
.modal-card {
  width: 700px !important;
  -webkit-box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.2) !important;
  -moz-box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.2) !important;
  box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.2) !important;
  border-radius: 10px;
  .delete {
    background-color: rgba(140, 0, 45, 0.2);
    transition: 0.3s;

  }
  .delete:hover {
    background-color: rgba(140, 0, 45, 0.5);
  }
  .my-subtitle {
    color: rgb(140, 0, 45);
    opacity: 0.3;
    font-size: 12px;
  }
}
.modal-background {
  background-color: transparent !important;
}
.is-success {
  background: rgb(45, 140, 0) !important;
  transition: 0.3s;
}
.mygreenbtn {
  background: rgb(45, 140, 0) !important;
}
.is-danger {
  background: rgb(140, 0, 45) !important;
  transition: 0.3s;
}

.is-warning {
  background: #c5bf0e !important;
  transition: 0.3s;
}

.my-map-link {
  text-decoration: underline 1px dashed rgb(45, 140, 0);
  border-radius: 5px;
  transition: 0.3s;
}
.my-map-link:hover {
  cursor: pointer;
  color: rgb(45, 140, 0);
  text-decoration: underline 1px solid rgb(45, 140, 0);
}

.my-edit-button {
  border: 1px dotted rgba(0, 0, 0, 0.1) !important;
  background: transparent !important;
  width: 30px;
  transition: 0.4s;
  color: rgb(130, 112, 118) !important;
}
.my-edit-button:hover {
  border: 1px solid rgba(0, 0, 0, 0) !important;
  background: rgb(45, 140, 0) !important;
  color: #fff !important;
}

.my-edit-button:hover .pen {
  animation: whrite infinite 1s ease-in-out;
}

@keyframes whrite {
  0% {
    transform: translateX(0);
    margin-left: 0;
    rotate: 0;
  }
  25% {
    rotate: -5deg;
  }
  50% {
    rotate: 0;
    transform: translateX(2px);
  }
  75% {
    rotate: 5deg;
  }
  100% {
    rotate: 0;
    transform: translateX(0);
  }
}


</style>
